import _typeof from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { singleServeStatic } from "@/api/bpmnApi/bpmn";
export default {
  name: "useServeInfoDialog",
  components: {},
  props: [],
  data: function data() {
    return {
      show: false,
      loading: false,
      row: {},
      resData: {}
    };
  },
  computed: {},
  mounted: function mounted() {},
  methods: {
    submitForm: function submitForm() {},
    // 显示弹框
    dialogShow: function dialogShow(row) {
      this.show = true;
      this.row = row;
      var date = new Date();
      var year = date.getFullYear();
      var processDefId = row.processDefId || "obj_afbefa5389854e36b09749810b461dd4";
      this.singleServeStaticFn({
        year: year,
        processDefId: processDefId
      });
    },
    singleServeStaticFn: function singleServeStaticFn(params) {
      var _this = this;

      this.loading = true;
      singleServeStatic(params).then(function (_ref) {
        var data = _ref.data;
        _this.loading = false;

        if (data.code == 0) {
          _this.setEchart(data.data.chartData || []);

          _this.resData = data.data || {};
        }
      }).catch(function (err) {
        _this.loading = false;
      });
    },
    setEchart: function setEchart(data) {
      var labelList = data.map(function (i) {
        return i.name || "";
      });
      var dealNumList = data.map(function (i) {
        return i.dealNum;
      });
      var applyNumList = data.map(function (i) {
        return i.applyNum;
      });
      var dom = document.getElementById("echartsLine");
      var myChart = this.echarts.init(dom);
      var option = {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["服务次数", "服务人数"],
          bottom: 10 //legend距离canvas上面的距离

        },
        grid: {
          left: "10%",
          width: "80%",
          containLabel: false
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: labelList
        },
        yAxis: {
          name: "数量"
        },
        series: [{
          name: "服务次数",
          type: "line",
          smooth: true,
          lineStyle: {
            color: "#81D3CB"
          },
          color: "#81D3CB",
          data: applyNumList
        }, {
          name: "服务人数",
          type: "line",
          smooth: true,
          color: "#99ACFF",
          lineStyle: {
            color: "#99ACFF"
          },
          data: dealNumList
        }]
      };

      if (option && _typeof(option) === "object") {
        myChart.setOption(option, true);
      }
    }
  },
  filters: {}
};